import Cookies from 'universal-cookie';

import { decrypt, encrypt } from './encrypt';

const cookies = new Cookies(null, { path: '/' });

export const setUserToken = (data: ITokenData) =>
  cookies.set('hash', encrypt(JSON.stringify(data)));

export const getUserToken = (): ITokenData => {
  try {
    return cookies.get('hash')
      ? JSON.parse(decrypt(cookies.get('hash')!))
      : { accessToken: '', refreshToken: '' };
  } catch (err) {
    console.error(err);
    return { accessToken: '', refreshToken: '' };
  }
};

export const removeUserToken = () => cookies.remove('hash');

interface ITokenData {
  accessToken: string;
  refreshToken: string;
}
